export const FloatingBanner = {
	selectors: {
		root: document.querySelector('.js-floating-banner'),
		closeBtn: document.querySelector('.js-floating-banner__close')
	},

	cookieName: null,

	init: function () {
		const self = this;

		if (!this.selectors.root) {
			return;
		}

		self.cookieName = 'floatingBanner' + self.selectors.root.dataset.hash;

		// bind close
		self.selectors.closeBtn.addEventListener('click', () => self.close());

		// call open
		self.open();
	},

	open: function () {
		const self = this;

		// check cookie
		const hasCookie = document.cookie
			.split(';')
			.some((x) => x.trim().startsWith(`${self.cookieName}=`));

		if (hasCookie) {
			return;
		}

		// show after delay
		const delay = self.selectors.root.dataset.openDelay || 0;
		setTimeout(() => self.selectors.root.classList.add('is-open'), delay);
	},

	close: function () {
		const self = this;

		// hide
		self.selectors.root.classList.remove('is-open');

		// create cookie, expires in 1 year
		const expires = new Date();
		expires.setTime(expires.getTime() + (365 * 24 * 60 * 60 * 1000));
		document.cookie = `${self.cookieName}=seen; expires=${expires}; path=/`;
	}
};

FloatingBanner.init();
